import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../libs'
import { TCreateWithdrawalGroup } from './types'
import {
  gatewayMounted,
  setError,
  submitSaveGateway,
} from '../../gateway/create/model'
import { getGateway } from '../../gateway/edit'
import {
  saveAccess,
  saveOperation,
  saveWeight,
  updateGateway,
} from '../../gateway/edit/model'

export const setWithdrawalGroup = createEvent<TCreateWithdrawalGroup>()
export const submitCreateWithdrawalGroup = createEvent<TCreateWithdrawalGroup>()
export const $withdrawalGroup = restore(setWithdrawalGroup, {
  id: 0,
  name: '',
})
export const $error = restore(setError, {
  message: '',
  code: 0,
})
export const createWithdrawalGroup = fx<TCreateWithdrawalGroup, void>({
  method: 'POST',
  url: '/withdrawal_group',
})

sample({
  clock: submitCreateWithdrawalGroup,
  fn: (withdrawalGroup) => {
    return {
      url: `/withdrawal_group`,
      body: { ...withdrawalGroup },
    }
  },
  target: createWithdrawalGroup,
})

sample({
  clock: [createWithdrawalGroup.failData],
  fn: (failData) => {
    return { message: failData.body.message, code: failData.body.code }
  },
  target: [setError],
})

sample({
  //@ts-ignore
  clock: [createWithdrawalGroup.doneData],
  fn: (doneData) => {
    return { id: '', name: '' }
  },
  target: [setWithdrawalGroup],
})

$error.on(submitCreateWithdrawalGroup, () => {
  return {
    message: '',
    code: 0,
  }
})
